import { triggerAdRequest, triggerAdsReady } from './ad-event-triggers';
import { AdCuePoint, AdObject, AdPluginSettings } from './ad-types';
import { playImageAd } from './play-image-ad';
import { playVideoAd } from './play-video-ad';

export function onPreRoll(
  player: any,
  adCue: AdCuePoint,
  ad: AdObject,
  settings: AdPluginSettings
) {
  return function () {
    if (ad.type === 'VIDEO') {
      playVideoAd(player, 'PREROLL', adCue, ad, settings);
    } else {
      playImageAd(player, 'PREROLL', adCue, ad, settings);
    }
  };
}

export function initializePreroll(
  player: any,
  cue: AdCuePoint,
  settings: AdPluginSettings
) {
  triggerAdRequest(player, 'PREROLL', 0, cue);
  settings.adsProvider
    .getAd('PREROLL', cue.id, player.liveTracker.isLive())
    .then((response) => {
      if (response) {
        player.one(
          'readyforpreroll',
          onPreRoll(player, cue, response, settings)
        );
      } else {
        player.one('readyforpreroll', () => player.trigger('nopreroll'));
      }
      triggerAdsReady(player, cue, response);
    });
}

export function cancelPreroll(player: any, settings: AdPluginSettings) {
  player.one('readyforpreroll', () => player.trigger('nopreroll'));
  player.trigger('adsready');
}
